import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { Apollo, MutationResult } from 'apollo-angular';

import { SHARE_PROPERTY } from '@graphql/mutations/share.mutations';
import {
  ISharePropertyInput,
  ISharePropertyResult,
} from '@shared/models/share';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(private apollo: Apollo) {}

  shareProperty(
    input: ISharePropertyInput
  ): Observable<MutationResult<ISharePropertyResult>> {
    return this.apollo
      .mutate({
        mutation: SHARE_PROPERTY,
        variables: input,
      })
      .pipe(
        catchError((error) => {
          throw error;
        })
      );
  }
}
